/** Digits only from a phone field value. */
export function phoneDigits(value: string): string {
  return value.replace(/\D/g, '');
}

/**
 * Normalize US / NANP input to E.164 `+1XXXXXXXXXX`.
 * Accepts 10-digit national, 11-digit with leading 1, and formatted variants
 * (`+1 2128143681`, `(732) 555-0123`, etc.). Returns null when not a valid US number.
 */
export function normalizeUsPhoneE164(raw: string): string | null {
  let digits = phoneDigits(raw);
  if (digits.length === 10) digits = `1${digits}`;
  if (digits.length !== 11 || !digits.startsWith('1')) return null;
  // NANP: country 1, NXX NXX-XXXX with N in 2–9 for area and exchange.
  if (!/^1[2-9]\d{2}[2-9]\d{6}$/.test(digits)) return null;
  return `+${digits}`;
}

/** Format a US number for the input while typing (national, no `+1` prefix). */
export function formatUsPhoneInput(raw: string): string {
  let digits = phoneDigits(raw);
  if (digits.startsWith('1') && digits.length >= 11) digits = digits.slice(1, 11);
  else digits = digits.slice(0, 10);

  if (digits.length === 0) return '';
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}
